module.exports = "../study/imgs/maps/Nagano/GWQ8/Climate/SwelteringNight/Nagano_SwelteringNight_MRI_RCP85_End.png";